import { createDeleteEndpoint } from '@sonar-software/sonar-http';

export type DeleteInitiativeTaskRequest = {
	initiativeId: number;
	taskId: number;
};

export const deleteInitiativeTask = createDeleteEndpoint<DeleteInitiativeTaskRequest>(
	({ initiativeId, taskId }) => `/api/v3/initiatives/${initiativeId}/tasks/${taskId}`
);
